import { render } from "./UsuarioAdm01.vue?vue&type=template&id=9a9e4dc0"
import script from "./UsuarioAdm01.vue?vue&type=script&lang=js"
export * from "./UsuarioAdm01.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__